import React from 'react';
export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  hoverable?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}
export function Card({
  children,
  hoverable = false,
  padding = 'md',
  className = '',
  ...props
}: CardProps) {
  const baseStyles = 'bg-white rounded-2xl shadow-sm border border-slate-100';
  const hoverStyles = hoverable ? 'transition-shadow duration-200 hover:shadow-md cursor-pointer' : '';
  const paddings = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  };
  // Only add overflow-hidden for cards with no padding (image cards)
  const overflowStyle = padding === 'none' ? 'overflow-hidden' : '';
  return <div className={`${baseStyles} ${overflowStyle} ${hoverStyles} ${paddings[padding]} ${className}`} {...props} data-id="element-15479">
      {children}
    </div>;
}